export class Language {
    private static Phrases={
        English:{
            today:'Today',
            thisweek:'This Week',
            nextweek:'Next Week',
            meetingreport:'Meeting Report',
            opportunity:'Opportunity',
            plannertask:'Planner Task',
            meeting:'Meeting',
            todo:'Outlook To-Do',
            all:'All',
            switchcallview:'Calendar view',
            overdue:'Over due',
            week:'Week',
            to:'to',
            options:'Options',
            switchview:'Switch view',
            markcomplete:'Mark Complete',
            savesummary:'Save Summary',
            start:'Start',
            end:'End',
            organizer:'Organizer',
            location:'Location',
            edit:'Edit',
            setduedate:'Set due date',
            showcomments:'Show comments',
            notstarted:'Not started',
            inprogress:'In progress',
            due:'Due',
            completedcount:'{0} completed',
            attachmentcount:'{0} attachment(s)',
            commentscount:'Comments {0}',
            savelog:'Save log',
            setfollowupdate:'Set follow-up date',
            probability:'Probability',
            expectedclouser:'Closing date',
            potential:'Potential',
            status:'Status',
            importance:'Importance',
            reportdate:'Report date',
            contacttype:'Contact type',
            company:'Company',
            contact:'Contact',
            summary:'Summary',
            customersatisfaction:'Customer satisfaction',
            economictrends:'Economic trends',
            followupdate:'Follow-up date',
            assigned:'Assigned',
            unassigned:'Unassigned',
            assignto:'Assign to',
            remove:'Remove',
            searchplaceholder:'Search...',
            promotitem:'Promote item',
            removecheckitem:'Remove checklist item',
            orgexistmessage:'Your organization - {0} - is already using MIPA. Please contact - {1} to request access to MIPA.',
            liclimitexceded: 'License limit exceeded!',
            liclimitadminmessage: 'please remove {0} User(s) from the list and reload the add in.',
            liclimitusermesasge: 'ask your administrator to remove {0} User(s).',
            useractivity:'Your activities',
            thisweekactivity:'This week activities',
            nextweekactivity:'Next week activities',
            groupactivity:'Group Activity',
            showweekend:'Show Weekend',
            sensitivity:'Sensitivity',
            additionalcontact:'Additional contact',
            orgliclimitescedmessage:'Your organization - {0} - has exceeded the number of purchased licenses. Please contact - {1} to request access to MIPA.',
            flaggedemail:'Flagged Email',
            mailfrom:'From',
            category:'Category',
            newplantask:'New Task',
            completed:'Completed',
            urgent:'Urgent',
            important:'Important',
            medium:'Medium',
            low:'Low',
            edittaskdescription:'Edit Description',
            save:'Save',
            plancaption:'plan',
            selectplan:'Select a plan',
            tasktitlecaption:'Task Title',
            textplaceholder:'Please enter text here',
            bucket:'Bucket',
            selectbucket:'Select bucket',
            progress:'Progress',
            selecttaskstatus:'Select status',
            showoncard:'Show on card',
            desctrictioncaption:'Notes',
            addattachment:'Add Attachment',
            cancel:'Cancel',
            addnewlink:'Add New Link',
            addresscaption:'Address',
            addressplaceholder:'Add your link here',
            linkalisecaption:'Text to display',
            linkaliseplaceholder:'Give your link name here',
            linkvalidationreq:'Please enter url',
            linkvalidationvalid:'Please enter valid url',
            linkalisevalidationreq:'Please enter display text',
            checklist:'Checklist',
            planselectvalidaiton:'Please select a plan',
            tasktitlevalidaiton:'Please enter task title',
            bucketvalidation:'Please select a bucket',
            taskassigneevalidation:'Please select assignee',
            checklistvalidation:'Please enter checklist title or remove empty checklist item',
            attachfile:'File',
            attachlink:'Link',
            attachmail:'Mail',
            addchecklist:'Add a checklist',
            bookpreperationheading: 'Book preparation time',
            book15minbefor: '15 min before',
            book30minbefor: '30 min before',
            bookbutton:'Book',
            book15minbooked: '15 min booked',
            book30minbooked: '30 min booked',
            bookeventsubject: 'Preparation time for {0}',
            outlookeventattending: 'Attending',
            outlookeventinvited: 'Invited',
            outlookeventTentative: 'Tentative',
            outlookeventDeclined: 'Declined',
            outlookeventnoresponse: 'No response',
            outlookeventnoattendee: 'No attendees to show',
            outlookaccepted: 'You accepted',
            outlookeventresponse: 'Response',
            outlookeventresponseyes:'Yes',
            outlookeventresponseno: 'No',
            recentactivity:'Recent activity',
            recentfiles:'Recent files',
            sharedfiles:'Shared files',
            activeworks:'Your active work',
            showattachments:'Show attachments',
            hideattachments:'Hide attachments',
            attachments:'Attachments',
            FlagedEmail:'Flaged Email',
            MSList:'Microsoft List',
            fullView:'Full View',
            shortview:'Short View',
            Home:'Home',
            PlannerDashboard:'Planner Dashboard',
            Late:'Late',
            Matrix:'Matrix',
            matrixheadingimportant:'Important',
            matrixheadingnotimportant:'Not Important',
            matrixheadingurgent:'Urgent',
            matrixheadingnoturgent:'Not Urgent',
            addtask:'Add task',
            addnote:'Add note',
            addlink:'Add link',
            priority:'Priority',
            noduedate:'No due date',
            licdayremain: 'License will expire in {0} day(s).',
            attachmentfrommailbox:'Attachments from mailbox',
            userlateactivity:'Your late activities',
            booktimeinyourcalendar: 'Book time in your calendar',
            book: 'Book',
            dueDate: 'Due Date',
            time: 'Time',
            timeStart: 'Time Start',
            timeEnd: 'Time End',
            duration: 'Duration',
            timeEndMustGreaterThenTimeStart: 'Time End must be greater then Time Start',
            eventCreatedSuccessfully: 'Time successfully added to your calendar',
            commentTextEventCreatedOnCalendarToBookTime: 'Event successfully added to calendar to book time',
            BookTimeCalendarEvent: 'Book Time Calendar Event',
            BookedTimeCalendarEventAlias: 'BookedTimeInCalendar',
            DueDateIsRequired: 'Date date is required',
            SelectTime: 'Select time',
            SelectDuration: 'Select duration',
            viewTask: 'Go to task',
            TaskPreparation: 'Task Preparation ',
            RefreshDashboard: 'Refresh dashboard'
        },
        Danish:{
            today:'I dag',
            thisweek:'Denne uge',
            nextweek:'Næste uge',
            meetingreport:'Møderapporter',
            opportunity:'Salgsmuligheder',
            plannertask:'Planner opgaver',
            meeting:'Møder',
            todo:'Outlook To-Do',
            all:'Alle',
            switchcallview:'Kalenderoversigt',
            overdue:'overskredet ',
            week:'Uge',
            to:'til',
            options:'Options',
            switchview:'Skift visning',
            markcomplete:'Marker som fuldført',
            savesummary:'Gem',
            start:'Startdato',
            end:'Forfaldsdato',
            organizer:'Organizer',
            location:'Lokation',
            edit:'Rediger',
            setduedate:'Angiv forfaldsdato',
            showcomments:'Vis kommentar',
            notstarted:'Ikke startet',
            inprogress:'I gang',
            due:'forfald',
            completedcount:'{0} Fuldførte',
            attachmentcount:'{0} Vedhæftninger',
            commentscount:'Kommentarer {0}',
            savelog:'Gem',
            setfollowupdate:'Angiv opfølgningsdato',
            probability:'Sandsynlighed',
            expectedclouser:'Forventet lukket',
            potential:'Potentiale',
            status:'Status',
            importance:'Prioritet',
            reportdate:'Rapporteret den',
            contacttype:'Type',
            company:'Firma',
            contact:'Kontakt',
            summary:'Resume',
            customersatisfaction:'Tlfredshed',
            economictrends:'Tendenser',
            followupdate:'Opfølgningsdato',
            assigned:'Tildelt',
            unassigned:'Ikke tildelt',
            assignto:' Tildelt til',
            remove:'Fjern',
            searchplaceholder:'Søg...',
            promotitem:' Hæv element',
            removecheckitem:' Fjern tjeklisteelement',
            // tslint:disable-next-line: max-line-length
            orgexistmessage:' Din organisation-{0}- abonnerer allerede MIPA. Kontakt-{1} for at anmode om adgang til MIPA.',
            liclimitexceded: 'Din organisation har ikke flere ledige licenser til MIPA!',
            liclimitadminmessage: 'Giv adgang til MIPA ved at fjerne {0} en bruger eller tilkøb flere licenser.',
            liclimitusermesasge: ' Kontakt MIPA administratoren.',
            useractivity:'Dine aktiviteter',
            thisweekactivity:'Denne uges aktiviteter',
            nextweekactivity:'Næste uges aktiviteter',
            groupactivity:' Gruppeaktivitet',
            showweekend:'Vis Weekend',
            sensitivity:' Følsomhed',
            additionalcontact:'Additional contact',
            orgliclimitescedmessage:'Din organisation - {0} - har overskredet antallet af købte licenser. Kontakt venligst - {1} for at anmode om adgang til MIPA',
            flaggedemail:'Flag en E-mail',
            mailfrom:'Fra',
            category:' Etiket',
            newplantask:'Ny opgave',
            completed:' Fuldført',
            urgent:'Presserende',
            important:' Vigtigt',
            medium:'Medium',
            low:'Lav',
            edittaskdescription:'Rediger beskrivelsen',
            save:'Gem',
            plancaption:'Plan',
            selectplan:'Vælg en Plan',
            tasktitlecaption:'Opgave titel',
            textplaceholder:' Indtast tekst her',
            bucket:'Filsæt',
            selectbucket:'Vælg Filsæt',
            progress:'Opgavestatus',
            selecttaskstatus:'Vælg status',
            showoncard:'Vise på kortet',
            desctrictioncaption:'Noter',
            addattachment:'Vedhæftet fil',
            cancel:'Fortryd',
            addnewlink:'Tilføj et link',
            addresscaption:'Adresse',
            addressplaceholder:' Tilføj linket her',
            linkalisecaption:'Tekst til linket',
            linkaliseplaceholder:'Udfyld link navnet her',
            linkvalidationreq:' Udfyld en URL-adresse',
            linkvalidationvalid:' Angiv en valid URL-adresse ',
            linkalisevalidationreq:'Angiv venligst et navn til linket',
            checklist:'Tjekliste',
            planselectvalidaiton:'Vælg venligst en Plan',
            tasktitlevalidaiton:'Angiv en opgave titel',
            bucketvalidation:'Vælg venligst et Filsæt',
            taskassigneevalidation:'Tilel venligst opgaven',
            checklistvalidation:'Angiv et navn for tjeklisteemnet eller fjern emnet.',
            attachfile:'Fil',
            attachlink:'Link',
            attachmail:'Mail',
            addchecklist:'Tilføj tjekliste',
            bookpreperationheading: 'Book preparation time',
            book15minbefor: '15 min before',
            book30minbefor: '30 min before',
            bookbutton:'Book',
            book15minbooked: '15 min booked',
            book30minbooked: '30 min booked',
            bookeventsubject: 'Preparation time for {0}',
            outlookeventattending: 'Attending',
            outlookeventinvited: 'Invited',
            outlookeventTentative: 'Tentative',
            outlookeventDeclined: 'Declined',
            outlookeventnoresponse: 'No response',
            outlookeventnoattendee: 'No attendees to show',
            outlookaccepted: 'You accepted',
            outlookeventresponse: 'Response',
            outlookeventresponseyes:'Yes',
            outlookeventresponseno: 'No',
            recentactivity:'Recent activity',
            recentfiles:'Recent files',
            sharedfiles:'Shared files',
            activeworks:'Your active work',
            showattachments:'Show attachments',
            hideattachments:'Hide attachments',
            attachments:'Attachments',
            FlagedEmail:'Flaged Email',
            MSList:'Microsoft List',
            fullView:'Full View',
            shortview:'Short View',
            Home:'Home',
            PlannerDashboard:'Planner Dashboard',
            Late:'Late',
            Matrix:'Matrix',
            matrixheadingimportant:'Important',
            matrixheadingnotimportant:'Not Important',
            matrixheadingurgent:'Urgent',
            matrixheadingnoturgent:'Not Urgent',
            addtask:'Add task',
            addnote:'Add note',
            addlink:'Add link',
            priority:'Priority',
            noduedate:'No due date',
            licdayremain: 'License will expire in {0} day(s).',
            attachmentfrommailbox:'Attachments from mailbox',
            userlateactivity:'Your late activities',
            booktimeinyourcalendar: 'Book time in your calendar',
            book: 'Book',
            dueDate: 'Due Date',
            time: 'Time',
            timeStart: 'Time Start',
            timeEnd: 'Time End',
            duration: 'Duration',
            timeEndMustGreaterThenTimeStart: 'Time End must be greater then Time Start',
            eventCreatedSuccessfully: 'Time successfully added to your calendar',
            commentTextEventCreatedOnCalendarToBookTime: 'Event successfully added to calendar to book time',
            BookTimeCalendarEvent: 'Book Time Calendar Event',
            BookedTimeCalendarEventAlias: 'BookedTimeInCalendar',
            DueDateIsRequired: 'Date date is required',
            SelectTime: 'Select time',
            SelectDuration: 'Select duration',
            viewTask: 'Go to task',
            TaskPreparation: 'Task Preparation ',
            RefreshDashboard: 'Refresh dashboard'
        }
    };
    public static GetLanguageValue=(language,key)=> {
        let props='English';
        if(language == 'en-us') {
            props='English';
        } else if(language == 'da-dk') {
            props='Danish';
        }
        return Language.Phrases[props][key]!=null?Language.Phrases[props][key]:key;
    }
}